import React from 'react';
import './Contact.css';

export function Contact() {
  return (
    <div className="contact">
      <h2 className="contact-title">Contact Us</h2>
      <div className="contact-info">
        <p className="contact-item">
          <i className="fas fa-phone"></i> Phone: 
          <a href="tel:+916202071834"> +91 9625581855</a>
        </p>
        {/* <p className="contact-item">
          <i className="fas fa-phone"></i> Phone: 
          <a href="tel:+919973562183"> +91 9973562183</a>
        </p> */}
        <p className="contact-item">
          <i className="fas fa-envelope"></i> Email: 
          <a href="mailto:contact@moverspackers.com"> nehapackersmovers@gmail.com</a>
        </p>
        <p className="contact-item">
          <i className="fas fa-map-marker-alt"></i> Office Address 1: Gaya, Gewal biga More, Police Line - 823001
        </p>
        <p className="contact-item">
          <i className="fas fa-map-marker-alt"></i> Office Address 2: Patna, Methapur, Parsa Bazar Road - 800001
        </p>
        <p className="contact-item">
          <i className="fas fa-map-marker-alt"></i> Office Address 3: Hatia, Singh More, Vikash Nagar Ranchi - 834005
        </p>
        <p className="contact-item">
          <i className="fas fa-map-marker-alt"></i> Office Address 4: A 15, Sayamnagar, Okhla Phase 3, New Delhi - 110020
        </p>
      </div>
    </div>
  );
}
